import { BaseContainerModel } from '../base-container.model';
import {
    bl_fi_generic_doc_message_template_endpoint_link_RowInterface,
    bl_fi_generic_doc_message_template_endpoint_link_RowClass
  } from '../../dbschema/index';
export class GenericDocMessageTemplateEndpointLinkContainer extends BaseContainerModel {
    bl_fi_generic_doc_message_template_endpoint_link: bl_fi_generic_doc_message_template_endpoint_link_RowInterface = new bl_fi_generic_doc_message_template_endpoint_link_RowClass();
}